import { FIT_TYPES } from './constants.js';

const devices = ['default', 'mobile', 'tablet', 'desktop'];

function validateString(fit) {
    if (!FIT_TYPES.includes(fit)) {
        throw new Error(`Available fit types: "${FIT_TYPES.join('m ')}"\nInput: "${fit}"`);
    }

    return true;
}

function validateObject(fit) {
    const invalidDevices = Object.keys(fit).filter((key) => !devices.includes(key));
    if (invalidDevices.length) {
        throw new Error(`Available device types: "${devices.join(', ')}\nInput: "${invalidDevices.join(', ')}"`);
    }

    const invalidFits = Object.values(fit).filter((val) => !FIT_TYPES.includes(val));
    if (invalidFits.length) {
        throw new Error(`Available fit types: "${FIT_TYPES.join(', ')}"\nInput: "${invalidFits.join(', ')}"`);
    }

    return true;
}

export default (fit) => {
    if (typeof fit === 'string') {
        return validateString(fit);
    }

    if (typeof fit === 'object') {
        return validateObject(fit);
    }

    throw new Error('Fit can only be of type: "string, object"');
};
